import { WEB_BASE_URL } from "../constants";
import { removeAuthToken } from "./secureStorage";

// A custom event name used to notify the app (and other tabs) about a forced logout
export const LOGOUT_EVENT = "app:force-logout";

export interface ILogoutEventDetail {
	reason?: "unauthorized" | "timeout" | "manual" | "unknown";
	statusCode?: number;
	message?: string;
}

export const emitLogout = (detail?: ILogoutEventDetail): void => {
	try {
		window.dispatchEvent(new CustomEvent(LOGOUT_EVENT, { detail }));
	} catch (e) {
		// older browsers
		// eslint-disable-next-line no-console
		console.warn("Failed to dispatch logout event", e);
	}
};

export const onLogout = (listener: (e: CustomEvent<ILogoutEventDetail>) => void): void => {
	window.addEventListener(LOGOUT_EVENT, listener as EventListener);
};

export const offLogout = (listener: (e: CustomEvent<ILogoutEventDetail>) => void): void => {
	window.removeEventListener(LOGOUT_EVENT, listener as EventListener);
};

export const logout = (postAction: () => any, detail?: ILogoutEventDetail): void => {
	removeAuthToken();
	emitLogout(detail);
	postAction();
};

// Unified helper for 401 Unauthorized handling with redirect
export const logoutUnauthorizedRedirectToWeb = (): void => {
	try {
		logout(
			() => {
				// window.location.href = SSO_URL;
				window.location.href = WEB_BASE_URL;
			},
			{ reason: "unauthorized", statusCode: 401, message: "Session expired or invalid token" }
		);
	} catch (_) {
		// ignore
	}
};
